import { useEffect } from 'react'

const INPUT_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

/**
 * Register global keyboard shortcuts.
 * @param {Array<{ key: string, meta?: boolean, handler: (e: KeyboardEvent) => void }>} shortcuts
 */
export default function useKeyboardShortcuts(shortcuts) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const inInput = INPUT_TAGS.has(document.activeElement?.tagName)

      for (const shortcut of shortcuts) {
        const keyMatch = e.key.toLowerCase() === shortcut.key.toLowerCase()
        const metaMatch = shortcut.meta
          ? (e.metaKey || e.ctrlKey)
          : true

        if (!keyMatch || !metaMatch) continue

        // Allow Escape even in inputs; block others
        if (inInput && shortcut.key.toLowerCase() !== 'escape') continue

        e.preventDefault()
        shortcut.handler(e)
        return
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts])
}
